import { Fragment } from 'react'

export const Highlighted = ({ highlights }: { highlights: string[] }) => {
  return (
    <>
      {highlights?.map((match, i) => {
        return (
          <Fragment key={`${i}-${match}`}>
            {i % 2 === 0 ? match : <b>{match}</b>}
          </Fragment>
        )
      })}
    </>
  )
}
